import React from "react";
import ReactDOM from "react-dom/client";
 
// import './App.css';

import "remixicon/fonts/remixicon.css";
import "bootstrap/dist/css/bootstrap.css";

import App from "./App";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContextProvider } from "./contexts/ContextProviders";
import { SocketProvider } from "./contexts/SocketContext";
import { ToastProvider } from "./components/ExplorerModule/toastnew";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ContextProvider>
    <React.StrictMode>
      <HashRouter>
        <Provider store={store}>
          <SocketProvider>
            <ToastContainer
              // theme="dark"
              position="top-right"
              autoClose={2000}
              closeOnClick
              pauseOnHover={false}
            />
            <ToastProvider>
            <App />
            </ToastProvider>
          </SocketProvider>
        </Provider>
      </HashRouter>
    </React.StrictMode>
  </ContextProvider>
);